import Mustache from 'Mustache';
import imageLazyLoad from './lazyload';
import smoothscroll from 'smoothscroll-polyfill';
import 'whatwg-fetch';

const loadTopStories = function(){
  let button;
  let buttonToTop;
  let container;
  let template;
  let url;
  let posts;

  const _init = () => {
    button = document.getElementById('load-topstories');
    buttonToTop = document.getElementById('back-to-top');
    url = `/api/?action=get_top_stories&offset=${getUrlOffset()}`;
    template = document.getElementById('top-story-template').innerHTML;
    Mustache.parse(template);
    container = document.getElementById('top-story-container');

    button.addEventListener('click', fetchData, false);
    buttonToTop.addEventListener('click', toTop, false);
  };

  const fetchData = () => {
    button.disabled = true;
    document.body.classList.add('is-fetching-data');

    fetch(url, {
      method: 'get',
      credentials: 'same-origin',
    })
      .then(res => res.json())
      .then(data => {
        document.body.classList.remove('is-fetching-data');
        setTemplate(data.posts);
      });
  }

  const setTemplate = (arr) => {
    const html = Mustache.render(template, {posts: arr});
    container.innerHTML = html;
    imageLazyLoad.init();

    button.remove();
    buttonToTop.style.display = 'block';
    handleShareBtns();
  }

  const toTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  const handleShareBtns = () => {
    const facebookShareBtns = container.querySelectorAll('.share-facebook');
    const linkedinShareBtns = container.querySelectorAll('.share-linkedin');
    const twitterShareBtns = container.querySelectorAll('.share-twitter');

    for (let i = 0; i < facebookShareBtns.length; i++) {
      facebookShareBtns[ i ].addEventListener('click', onShareBtnClick);
    }

    for (let j = 0; j < linkedinShareBtns.length; j++) {
      linkedinShareBtns[ j ].addEventListener('click', onShareBtnClick);
    }

    for (let k = 0; k < linkedinShareBtns.length; k++) {
      twitterShareBtns[ k ].addEventListener('click', onShareBtnClick);
    }
  };

  const onShareBtnClick = (e) => {
    e.preventDefault();
    var w = 900;
    var h = 500;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = ((width / 2) - (w / 2));
    var top = ((height / 2) - (h / 2));

    window.open(e.currentTarget.getAttribute('href'), 'share', 'left=990, width=600, height=350, top='+top+', left='+left+'');

    return false;
  };

  const getUrlOffset = () => {
    // TODO: EmerceTV check what homepage component is set!
    if (document.querySelector('.m-container-content .m-banner--top-story')) {
      return 22;
    }

    return 22; // Used to be 21. ^ Doesnt exist anymore.
  }

  return {
    init: _init
  }
}();


if(document.getElementById('load-topstories')){
  loadTopStories.init();
};
